<template>

      <v-row>
        <div class="col-md-12 home-box">
          <Breadcrumbs :title="'Purchase Orders'"></Breadcrumbs>
          <PoList></PoList>
        </div>
        <div class="col-md-12 home-tabs-body">
        </div>
      </v-row>
    
  </template>
 
  
  <script>
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
  import PoList from "@/components/purchaseorder/PoList.vue";
  export default {
    components:{Breadcrumbs,PoList},
  }

  </script>
  
 
  